import FormattedMessage from 'I18n/components/FormattedMessage';
import { BreezeSingleStarIcon } from 'foundations-assets';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { useMemo } from 'react';
import { isSucceeded } from 'reporting-data/asyncData/AsyncData';
import ReportCardV2 from 'reporting-enablement/components/ReportCard/ReportCardV2';
import ReportingAIAssistantContent from 'reporting-enablement/components/singleReportViewer/fullPage/report-ai-assistant-insights/ReportingAIAssistantContent';
import { useProperty } from '../rewrite/properties/hooks/useProperty';
import { useFetchColumnInsights } from './useFetchColumnInsights';
import { createVisualReport } from './utils/reportCreationUtils';
import { useIsUngatedForVizSettingsM1 } from '../auth/hooks/useIsUngatedForVizSettingsM1';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ColumnInsightsContent = ({
  handleGenerate,
  columnName,
  filterGroups,
  query,
  objectTypeId
}) => {
  const isUngatedForVizSettingsM1 = useIsUngatedForVizSettingsM1();
  const {
    report,
    reportResolve,
    reportInsightsFetch,
    isInsightLoading
  } = useFetchColumnInsights({
    columnName,
    objectTypeId,
    filterGroups,
    query
  });
  const propertyData = useProperty(columnName);
  const {
    type: propertyType,
    numberDisplayHint
  } = propertyData !== null && propertyData !== void 0 ? propertyData : {};
  const visualReport = useMemo(() => createVisualReport(columnName, objectTypeId, filterGroups, query, propertyType, numberDisplayHint), [columnName, objectTypeId, filterGroups, query, propertyType, numberDisplayHint]);
  if (!columnName || !report || !reportResolve) {
    return null;
  }
  const isInsightFetchSucceeded = isSucceeded(reportInsightsFetch);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsxs(Button, {
        "data-test-id": "column-insights-generate-button",
        size: "sm",
        use: "tertiary-extra-light",
        onClick: handleGenerate,
        disabled: isInsightLoading,
        marginBlockEnd: "400",
        children: [/*#__PURE__*/_jsx(BreezeSingleStarIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: isUngatedForVizSettingsM1 ? 'indexPage.columnInsights.generate' : 'index.columnInsights.panel.generate'
        })]
      }), /*#__PURE__*/_jsx(ReportingAIAssistantContent, {
        report: report,
        reportResolve: reportResolve,
        insightFetch: reportInsightsFetch
      })]
    }), isInsightFetchSucceeded && visualReport && /*#__PURE__*/_jsx(View, {
      maxBlockSize: "600px",
      children: /*#__PURE__*/_jsx(ReportCardV2, {
        report: visualReport,
        addOns: ['VIEW_SRV']
      })
    })]
  });
};